import {ICase} from "../../components/BlockCases/interfaces";
import blockIntegration from './BlockIntegrationTexts';
import calculator from './CalculatorTexts';
import deliveryBlockInfo from './DeliveryBlockInfoTexts';
import header from "./HeaderTexts";
import mapMainBlock from "./MapMainTexts";
import tellAboutTasksBlock from './TellAboutTasksTexts';
import termsDeliveryBlock from './TermsDeliveryTexts';
import {textareaMaxSymbols} from "./Constants";
import {defaultValueForImage, isGeneration, loadContent, mergeContent} from "./functions";

let blockCases = {
  title: 'Оценка работы Dalli, от первых лиц',
  popularCases: 'Популярные кейсы',
  audioCaption: 'Выход в новые города',
  cases: [
    {
      title: 'Выявили аудиторию и расширили географию доставки',
      image: isGeneration ? defaultValueForImage : require('./img/BlockCases/1.png'),
      nameVideo: 'Видео Анатолия Иванова о Dalli в интервью с Times',
      items: [
        {text: 'Доставок новым клиентам', count: '20 000+'},
        {text: 'Успешных доставок', count: '97.8%'},
        {text: 'Средняя стоимость доставки', count: '320 р.'},
      ],
      audios: [{name: 'Аудитория'}, {name: 'Выход в новые города'}, {name: 'О курьерах'}],
    },
    {
      title: 'Выявили аудиторию и расширили географию доставки',
      image: isGeneration ? defaultValueForImage : require('./img/BlockCases/1.png'),
      nameVideo: 'Видео Анатолия Иванова о Dalli в интервью с Times',
      items: [
        {text: 'Доставок новым клиентам', count: '20 000+'},
        {text: 'Успешных доставок', count: '97.8%'},
        {text: 'Средняя стоимость доставки', count: '320 р.'},
      ],
      audios: [{name: 'Аудитория'}, {name: 'Выход в новые города'}, {name: 'О курьерах'}],
    },
    {
      title: 'Выявили аудиторию и расширили географию доставки',
      image: isGeneration ? defaultValueForImage : require('./img/BlockCases/1.png'),
      nameVideo: 'Видео Анатолия Иванова о Dalli в интервью с Times',
      items: [
        {text: 'Доставок новым клиентам', count: '20 000+'},
        {text: 'Успешных доставок', count: '97.8%'},
        {text: 'Средняя стоимость доставки', count: '320 р.'},
      ],
      audios: [{name: 'Аудитория'}, {name: 'Выход в новые города'}, {name: 'О курьерах'}],
    },
  ] as ICase[]
}

let blockWeAreTrusted = {
  title: "Доставляем 13 000+ заказов в день",
  titleText: 'для клиентов Dalli',
}

let breadcrumbsCustom = {
  main: 'Главная',
  services: 'Услуги',
}

let buttonsSpecial = {
  getInWhatsapp: 'Получить в WhatsApp',
  getInTelegram: 'Получить в Telegram',
  feedbackOborot: 'Отзывы на Oborot.ru',
  feedbackOborotShort: 'Oborot.ru',
}

let calculatorTable = {
  byCourier: 'Курьером до двери',
  byPvz: 'ПВЗ',
  byPost: 'Почта России',
  title: 'Способы и стоимость доставки',
  text: "Расчет предварительный, не включает в себя дополнительные опции и условия. Не является публичной офертой.",
  button: 'Получить предложение',
}

let cardService = {
  button1: 'Зона покрытия',
  button2: 'Тарифы и доп. услуги',
}

let common = {
  alertByParameter: `По заданным параметрам:`,
  textFrom: 'от',
  wordsDay: ['день', 'дня', 'дней'],
}

let cookies = {
  text: "Мы, как и все, используем <span>Cookie файлы</span> для улучшения работы сайта и аналитики. Вы можете запретить их использование в настройках браузера.",
  button: 'Принять',
}

let descriptionBlock = {
  showMore: 'Показать полностью...'
}

let errorTextBlocked = {
  message: 'Для отправки формы необходимо подождать еще',
}

let footer = {
  city1: 'Москва',
  city1Number: '+7 (495) 646-86-82',
  city2: 'Санкт-Петербург',
  city2Number: '+7 (812) 603-86-86',
  privacyPolicy: 'Политика конфиденциальности',
}

let formContacts = {
  steps: ['Оставьте ваши контакты', 'Подпишите договор', 'Настройте интеграцию'],
  button: 'Отправить',
  privacyPolicy: 'политикой конфиденциальности',
  title: 'Остались вопросы? Напишите нам',
  inputName: 'Имя',
  inputPhone: 'Телефон*',
  inputEmail: 'Email*',
  inputOrderNr: 'Номер заказа',
  inputMessage: 'Сообщение*',
  inputDepartment: 'Отдел*',
  inputCompanyName: 'Название компании',
  inputCity: 'Город',
  inputReason: 'Причина обращения*',
  text1: `Нажимая на кнопку “Отправить”, вы соглашаетесь с нашей `,
  text2: ` и даете согласие на обработку персональных данных`,
  topic: 'Тема обращения',
}

let formContainer = {
  phoneNumber: '+7(499)302-64-61'
}

let goodsBlock = {
  title: '10 лет опыта доставки',
  decorations: 'Украшения',
  cloths: 'Одежда',
  shoes: 'Обувь',
  appliances: 'Бытовая техника',
}

let guideBlock = {
  modalTitle: 'Получите гайд',
  modalButton: 'Получить гайд',
}

let mainBlock = {
  buttonDelivery: 'В регионы за 1 день',
  buttonIntegration: 'Интеграция за 1 день',
  buttonDeliveryPVZ: 'Собственная сеть ПВЗ',
  phone: 'Телефон',
  getProposal: 'Получить предложение',
  linkTracking: 'Отследить доставку',
  linkCalculator: 'Рассчитать стоимость доставки',
  linkDeliveryRu: 'Доставка по России',
  linkVacancies: 'Работа в Dalli',
}

let modalForm = {
  successText: 'Спасибо за заявку',
  successText2: 'Мы свяжемся с вами в ближайшее время',
  chooseTopic: 'Выберите тему обращения',
}

let serviceListMedia = {
  knowIt: 'Узнай',
  button: 'ZOOM с менеджером',
  buttonSend: '',
}

let sliderContent = {
  news: {
    title: 'Live',
    body: 'Говорим и показываем — внутренняя кухня, тренды и события отрасли',
  },
  reviews: {
    title: 'Что говорят наши клиенты'
  }
}

let textareaConstants = {
  max: `Максимум ${textareaMaxSymbols} символов`
}

let youtubeBlock = {
  watchFull: 'Смотреть полный выпуск'
}

const defaultContent = {
  blockIntegration,
  calculator,
  deliveryBlockInfo,
  header,
  mapMainBlock,
  tellAboutTasksBlock,
  termsDeliveryBlock,
  blockCases,
  blockWeAreTrusted,
  breadcrumbsCustom,
  buttonsSpecial,
  calculatorTable,
  cardService,
  common,
  cookies,
  descriptionBlock,
  errorTextBlocked,
  footer,
  formContacts,
  formContainer,
  goodsBlock,
  guideBlock,
  mainBlock,
  modalForm,
  serviceListMedia,
  sliderContent,
  textareaConstants,
  youtubeBlock,
}

const dynamicContent = loadContent();
export const content = mergeContent(defaultContent, dynamicContent);

